import { useEffect, useRef } from 'react';
import clsx from 'clsx';

export type TranscriptItem = {
  id: string;
  speaker: string | null;
  lang: string | null;
  text: string;
  ts: number;
  isFinal: boolean;
};

export function TranscriptStream({ items }: { items: TranscriptItem[] }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.scrollTop = el.scrollHeight;
  }, [items]);

  return (
    <div
      ref={ref}
      className="h-full overflow-y-auto px-4 pb-4 space-y-2 font-mono text-[13px] leading-relaxed"
    >
      {items.length === 0 ? (
        <div className="text-ink-3 text-center pt-6">
          Здесь появятся реплики, как только AI распознает речь.
        </div>
      ) : (
        items.map((t) => (
          <div key={t.id} className={clsx('rounded-xl px-3 py-2', isUser(t.speaker) ? 'bg-accent/10' : 'bg-white/[0.03]')}>
            <div className="text-[10px] text-ink-3 mb-0.5 flex items-center gap-2">
              <span>{t.speaker ?? 'speaker'}</span>
              {t.lang && <span>· {t.lang.toUpperCase()}</span>}
              <span className="ml-auto">{Math.floor(t.ts / 1000)}c</span>
              {!t.isFinal && (
                <span className="ml-1 text-ink-3 animate-pulseSoft">…</span>
              )}
            </div>
            <div className={clsx(t.isFinal ? 'text-ink-1' : 'text-ink-2 italic')}>
              {t.text}
            </div>
          </div>
        ))
      )}
    </div>
  );
}

function isUser(s: string | null): boolean {
  return !!s && /^USER/i.test(s);
}
